import React, { useState } from 'react';

function Contact() {
  const [formData, setFormData] = useState({
    name: '',
    phone: '',
    subject: '',
    message: ''
  });

  const [submitted, setSubmitted] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    // Here you can integrate with your backend email service (e.g., EmailJS, Formspree, Node API)
    setSubmitted(true);
  };

  return (
    <main className="contact-page" id="contact">
      {/* Hero Banner */}
      <section className="contact-hero" aria-labelledby="contact-title">
        <div className="contact-hero-inner">
          <div className="contact-hero-copy">
            <p className="contact-eyebrow">Get In Touch</p>
            <h1 id="contact-title">Contact <span>Us</span></h1>
            <p className="contact-lead">
              Have questions or need assistance? Reach out to us directly or send us a message below.
            </p>
          </div>
        </div>
      </section>

      {/* Main Content Area */}
      <div className="contact-content">
        <div className="contact-container">
          <div className="contact-grid">

            {/* Contact Details Card */}
            <div className="contact-info-card">
              <h2>Contact Information</h2>
              <p className="contact-info-sub">Feel free to visit us or reach out via email/phone.</p>

              <div className="contact-info-item">
                <div className="contact-info-icon" aria-hidden="true">📍</div>
                <div>
                  <h3>Contact Address</h3>
                  <p>Ward 14 Village Tillore Khurd<br />Dist Indore MP-452020</p>
                </div>
              </div>

              <div className="contact-info-item">
                <div className="contact-info-icon" aria-hidden="true">✉️</div>
                <div>
                  <h3>Mailing Address</h3>
                  <p>
                    <a href="mailto:schoolumiyapatidar@gmail.com">schoolumiyapatidar@gmail.com</a>
                  </p>
                </div>
              </div>

              <div className="contact-info-item">
                <div className="contact-info-icon" aria-hidden="true">📞</div>
                <div>
                  <h3>Contact Number</h3>
                  <p>
                    <a href="tel:9669745573">9669745573</a> | <a href="tel:9165622285">9165622285</a>
                  </p>
                </div>
              </div>
            </div>

            {/* Mail Send Form */}
            <div className="contact-form-card">
              <h2>Send Us a Message</h2>
              
              {submitted ? (
                <div className="contact-success-msg" role="alert">
                  <h3>Thank you for reaching out!</h3>
                  <p>Your message has been sent successfully. We will get back to you shortly.</p>
                  <button 
                    type="button" 
                    className="contact-btn" 
                    onClick={() => {
                      setSubmitted(false);
                      setFormData({ name: '', phone: '', subject: '', message: '' });
                    }}
                  >
                    Send Another Message
                  </button>
                </div>
              ) : (
                <form onSubmit={handleSubmit} className="contact-form">
                  

                  <div className="form-row">
                    <div className="form-group">
                    <label htmlFor="name">Full Name *</label>
                    <input
                      type="text"
                      id="name"
                      name="name"
                      required
                      placeholder="Enter your full name"
                      value={formData.name}
                      onChange={handleChange}
                    />
                  </div>

                    <div className="form-group">
                      <label htmlFor="phone">Phone Number</label>
                      <input
                        type="tel"
                        id="phone"
                        name="phone"
                        placeholder="Enter phone number"
                        value={formData.phone}
                        onChange={handleChange}
                      />
                    </div>
                  </div>

                  <div className="form-group">
                    <label htmlFor="subject">Subject *</label>
                    <input
                      type="text"
                      id="subject"
                      name="subject"
                      required
                      placeholder="Admission query, general inquiry, etc."
                      value={formData.subject}
                      onChange={handleChange}
                    />
                  </div>

                  <div className="form-group">
                    <label htmlFor="message">Message *</label>
                    <textarea
                      id="message"
                      name="message"
                      rows="5"
                      required
                      placeholder="Write your message here..."
                      value={formData.message}
                      onChange={handleChange}
                    ></textarea>
                  </div>

                  <button type="submit" className="contact-btn">
                    Send Message
                  </button>
                </form>
              )}
            </div>

          </div>
        </div>
      </div>
    </main>
  );
}

export default Contact;